"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var base_portfolio_config_model_1 = require("./base-portfolio-config.model");
var overview_config_model_1 = require("./overview-config.model");
var lodash_1 = require("lodash");
var RootEntityConfigModel = /** @class */ (function () {
    function RootEntityConfigModel(category, formName, overviewConfigModel, basePortfolioConfigModel) {
        this.category = category;
        this.formId = formName;
        this.overviewConfigModel = overviewConfigModel;
        this.basePortfolioConfigModel = basePortfolioConfigModel;
    }
    RootEntityConfigModel.emptyConfigs = function (category) {
        return new RootEntityConfigModel(category, null, new overview_config_model_1.OverviewConfigModel(), new base_portfolio_config_model_1.BasePortfolioConfigModel());
    };
    RootEntityConfigModel.prototype.clone = function () {
        return lodash_1.cloneDeep(this);
    };
    return RootEntityConfigModel;
}());
exports.RootEntityConfigModel = RootEntityConfigModel;
//# sourceMappingURL=root-entity-config.model.js.map